export default "__VITE_ASSET__d13fc401__"